import { HYROX_WORDMARK_PATHS, HYROX_WORDMARK_VIEWBOX } from '@/lib/brand-preview/hyrox-wordmark';

/**
 * HYROX wordmark, vectorised from the official logo SVG supplied for the demo
 * skin. Renders with currentColor so the same asset works white on dark,
 * black on light, or yellow. Height-driven; width follows the 520:72 ratio.
 * MyHyroxLockup composes it into the "myHYROX" sub-brand lockup.
 */
export function HyroxWordmark({ height = 16, className }: { height?: number; className?: string }) {
  return (
    <svg
      viewBox={HYROX_WORDMARK_VIEWBOX}
      height={height}
      width={Math.round(height * (520 / 72))}
      className={className}
      fill="currentColor"
      aria-label="HYROX"
      role="img"
    >
      {HYROX_WORDMARK_PATHS.map((d) => (
        <path key={d.slice(0, 16)} d={d} />
      ))}
    </svg>
  );
}

/**
 * The HYROX X alone, squared up, for where only a mark fits (the collapsed v8
 * rail). Same geometry as the wordmark's last letter; currentColor.
 */
export function HyroxMark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="458 -2 64 76"
      width={size}
      height={size}
      className={className}
      fill="currentColor"
      aria-label="HYROX"
      role="img"
      style={{ flex: 'none', display: 'block' }}
    >
      <path d={HYROX_WORDMARK_PATHS[HYROX_WORDMARK_PATHS.length - 1]} />
    </svg>
  );
}

/**
 * The "myHYROX" lockup: lowercase "my" prefix sized so its x-height matches
 * the HYROX cap height, baseline-aligned, with clear air between prefix and
 * wordmark. `size` is the HYROX cap height in px. Inherits currentColor.
 */
export function MyHyroxLockup({ size = 19, className }: { size?: number; className?: string }) {
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'baseline', gap: `${Math.round(size * 0.5)}px` }}
    >
      <span
        style={{
          fontFamily: 'var(--fv-font-display, var(--font-barlow-condensed))',
          fontWeight: 500,
          fontSize: `${Math.round(size * 1.3)}px`,
          lineHeight: 1,
          letterSpacing: '0.05em',
          textTransform: 'lowercase',
          color: 'var(--fv-accent)',
        }}
      >
        my
      </span>
      <HyroxWordmark height={size} />
    </span>
  );
}
